var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.examInfo && _vm.examAllow == true)?_c('div',[(_vm.$store.state.examInfo.answer_pre_remain_time)?_c('div',[(_vm.$store.state.examInfo.answer_pre_subject == 'CS')?_c('CRow',[(_vm.$store.state.examInfo.answer_pre_current_item <= 10)?_c('CCol',{staticClass:"bg-info text-center",staticStyle:{"padding":"20px","margin-bottom":"20px"},attrs:{"lg":"12"}},[_c('table',[_c('tr',[_c('td',{attrs:{"width":"50%"}},[_vm._v(" ข้อที่: "+_vm._s(_vm.$store.state.examInfo.answer_pre_current_item)+"/10 ")]),_c('td',{attrs:{"width":"50%"}},[_vm._v(" เหลือเวลา: "+_vm._s(_vm.$store.state.examInfo.answer_pre_remain_time)+" นาที ")])])])]):_c('CRow',{staticClass:"alert alert-success"},[_vm._v("ทดสอบก่อนอบรมเสร็จแล้วโปรดกลับ ไปยัง Dashboard")]),(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS1A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS1B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS1C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS1D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 1 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS2A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS2B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS2C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS2D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 2 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS3A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS3B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS3C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS3D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 3 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS4A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS4B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS4C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS4D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 4 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS5A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS5B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS5C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS5D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 5 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS6A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS6B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS6C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS6D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 6 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS7A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS7B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS7C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS7D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 7 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS8A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS8B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS8C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS8D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 8 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS9A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS9B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS9C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS9D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 9 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS10A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS10B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS10C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreCS10D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 10 ")]):_vm._e()],1):(_vm.$store.state.examInfo.answer_pre_subject == 'MA')?_c('CRow',[(_vm.$store.state.examInfo.answer_pre_current_item <= 10)?_c('CCol',{staticClass:"bg-warning text-center",staticStyle:{"padding":"20px","margin-bottom":"20px"},attrs:{"lg":"12"}},[_c('table',[_c('tr',[_c('td',{attrs:{"width":"50%"}},[_vm._v(" ข้อที่: "+_vm._s(_vm.$store.state.examInfo.answer_pre_current_item)+"/10 ")]),_c('td',{attrs:{"width":"50%"}},[_vm._v(" เหลือเวลา: "+_vm._s(_vm.$store.state.examInfo.answer_pre_remain_time)+" นาที ")])])])]):_c('CRow',{staticClass:"alert alert-success"},[_vm._v("ทดสอบก่อนอบรมเสร็จแล้วโปรดกลับ ไปยัง Dashboard")]),(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA1A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA1B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA1C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA1D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 1 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA2A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA2B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA2C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA2D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 2 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA3A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA3B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA3C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA3D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 3 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA4A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA4B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA4C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA4D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 4 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA5A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA5B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA5C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA5D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 5 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA6A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA6B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA6C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA6D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 6 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA7A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA7B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA7C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA7D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 7 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA8A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA8B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA8C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA8D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 8 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA9A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA9B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA9C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA9D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 9 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA10A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA10B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA10C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreMA10D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 10 ")]):_vm._e()],1):(_vm.$store.state.examInfo.answer_pre_subject == 'SC')?_c('CRow',[(_vm.$store.state.examInfo.answer_pre_current_item <= 10)?_c('CCol',{staticClass:"bg-success text-center",staticStyle:{"padding":"20px","margin-bottom":"20px"},attrs:{"lg":"12"}},[_c('table',[_c('tr',[_c('td',{attrs:{"width":"50%"}},[_vm._v(" ข้อที่: "+_vm._s(_vm.$store.state.examInfo.answer_pre_current_item)+"/10 ")]),_c('td',{attrs:{"width":"50%"}},[_vm._v(" เหลือเวลา: "+_vm._s(_vm.$store.state.examInfo.answer_pre_remain_time)+" นาที ")])])])]):_c('CRow',{staticClass:"alert alert-success"},[_vm._v("ทดสอบก่อนอบรมเสร็จแล้วโปรดกลับ ไปยัง Dashboard")]),(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC1A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC1B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC1C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC1D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '1E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 1 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC2A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC2B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC2C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC2D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '2E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 2 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC3A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC3B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC3C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC3D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '3E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 3 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC4A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC4B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC4C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC4D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '4E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 4 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC5A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC5B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC5C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC5D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '5E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 5 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC6A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC6B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC6C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC6D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '6E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 6 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC7A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC7B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC7C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC7D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '7E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 7 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC8A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC8B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC8C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC8D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '8E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 8 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC9A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC9B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC9C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9D'
          )?_c('CCol',{attrs:{"lg":"12"}}):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '9E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 9 ")]):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10A'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC10A')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10B'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC10B')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10C'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC10C')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10D'
          )?_c('CCol',{attrs:{"lg":"12"}},[_c('PreSC10D')],1):(
            _vm.itemList[_vm.$store.state.examInfo.answer_pre_current_item - 1] ==
            '10E'
          )?_c('CCol',{attrs:{"lg":"12"}},[_vm._v(" ข้อ 10 ")]):_vm._e()],1):_vm._e()],1):_c('div',{staticClass:"alert alert-danger"},[_vm._v("หมดเวลาทำแบบทดสอบ")])]):_c('div',{staticClass:"alert alert-danger"},[_vm._v(" อนุญาตให้ทำแบบทดสอบได้เมื่อ "+_vm._s(_vm.examStart)+" ถึง "+_vm._s(_vm.examEnd)+" "),_c('h1',[_vm._v("ห้ามเปิดต่างนี้ทิ้งไว้")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }